import baseRequest from "../_core/baseRequest";

export default {
    getAuthToken: params => {
        return baseRequest.apiRequest("POST", "/auth/token", params.data, params.apiKey);
    },
    getCompanyInfo: params => {
        return baseRequest.apiRequest(
            "GET",
            "/auth/my-company-info",
            undefined,
            params.apiKey,
            params.token
        );
    },
    createDelivery: params => {
        return baseRequest.apiRequest(
            "POST",
            "/courier/delivery",
            params.data,
            params.apiKey,
            params.token
        );
    },
    calculatePrice: params => {
        return baseRequest.apiRequest(
            "POST",
            `/pickupPoint/calculatePrice/${params.subCompanyId}`,
            {receiver: params.receiver},
            params.apiKey,
            params.token
        );
    }
};
